import makeStyles from "@mui/styles/makeStyles";

export const useStatusStyles = makeStyles(theme => ({
  approved: {
    color: theme.palette.approved,
    fontWeight: 600,
  },

  inactive: {
    color: theme.palette.inactive,
    fontWeight: 600,
  },

  takedown: {
    color: theme.palette.takedown,
    fontWeight: 600,
  },

  pending: {
    color: theme.palette.pending,
    fontWeight: 600,
  },

  rejected: {
    color: theme.palette.rejected,
    fontWeight: 600,
  },

  default: {
    fontStyle: "italic",
    color: theme.palette.primary.dark,
  },
}));

export const getStatusClass = (status, classes) => {
  switch (status) {
    case "APPROVED":
    case "ACTIVE":
      return classes.approved;
    case "PENDING":
      return classes.pending;
    case "REJECTED":
    case "DELETED":
      return classes.rejected;
    case "TAKEDOWN":
      return classes.takedown;
    case "INACTIVE":
      return classes.inactive;
    default:
      return classes.default;
  }
};
